import * as React from 'react';

const SecurityIcon = ({fillColor = '#2D2756'}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={14} height={18}>
    <path
      fill={fillColor}
      d="M6.146 9.98 4.5 8.332a.623.623 0 0 0-.458-.187.623.623 0 0 0-.459.187.623.623 0 0 0-.187.459c0 .18.062.333.187.458l2.063 2.063a.611.611 0 0 0 .448.187.611.611 0 0 0 .448-.188l3.854-3.854a.592.592 0 0 0 .166-.437.592.592 0 0 0-.166-.438.578.578 0 0 0-.427-.166.578.578 0 0 0-.427.166L6.146 9.98ZM7 17.27c-.056 0-.108-.003-.156-.01a.778.778 0 0 1-.136-.03c-1.86-.556-3.389-1.699-4.583-3.428C.931 12.072.333 10.174.333 8.104V4.021c0-.264.077-.504.23-.719.152-.215.347-.371.583-.469L6.563.813A1.28 1.28 0 0 1 7 .728c.139 0 .285.028.438.083l5.416 2.021c.236.098.43.254.584.469.152.215.229.455.229.719v4.083c0 2.07-.598 3.969-1.792 5.698-1.194 1.73-2.722 2.872-4.583 3.427L7 17.271Zm0-1.25c1.597-.527 2.9-1.524 3.906-2.989 1.007-1.465 1.51-3.107 1.51-4.927V4.021L7 1.979 1.583 4.021v4.083c0 1.82.504 3.462 1.51 4.927 1.008 1.465 2.31 2.462 3.907 2.99Z"
    />
  </svg>
);

export default SecurityIcon;
